import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/ask_question.svg'


const _withScopeId = n => (_pushScopeId("data-v-3b6f9158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "iconContainer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("label", { htmlFor: "createWorkspace" }, "Create a new Workspace")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "formContainer"
}
const _hoisted_9 = {
  key: 0,
  class: "red-text"
}
const _hoisted_10 = { class: "buttonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onExit && _ctx.onExit(...args))),
        class: "icon-button"
      }, _hoisted_4),
      _hoisted_5,
      _hoisted_6
    ]),
    (!_ctx.prodLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "loading..."))
      : _createCommentVNode("", true),
    (_ctx.prodLoaded && _ctx.canCreate())
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            id: "createWorkspace",
            class: "inputStyle",
            placeholder: "Enter a name for your Workspace",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workspaceName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.workspaceName]
          ]),
          (_ctx.inputErr.length !== 0)
            ? (_openBlock(), _createElementBlock("body", _hoisted_9, _toDisplayString(_ctx.inputErr), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args))),
              class: "rectangle-button buttonStyle"
            }, " Save ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}